import React, { useState } from 'react';
import './CardRevealPhase.css';
import Button from '../ui/Button';
import Card from '../ui/Card';
import { useGame } from '../../contexts/GameContext';
import { markPlayerReady } from '../../firebase/services';

const CardRevealPhase = () => {
  const { lobby, playerId, currentCard } = useGame();
  const [isMarking, setIsMarking] = useState(false);

  if (!lobby || !currentCard) {
    return <div className="card-reveal-loading">Yükleniyor...</div>;
  }

  const readyPlayers = lobby.readyPlayers || [];
  const isReady = readyPlayers.includes(playerId);
  const readyCount = readyPlayers.length;
  const totalCount = lobby.players.length;

  const handleReady = async () => {
    if (isMarking || isReady) return;
    setIsMarking(true);
    try {
      await markPlayerReady(lobby.code, playerId);
    } catch (error) {
      console.error('Error marking ready:', error);
    } finally {
      setIsMarking(false);
    }
  };

  return (
    <div className="card-reveal-phase">
      <div className="card-reveal-header">
        <h2>Kartın Dağıtıldı!</h2>
        <p>Aşağıda senin kartın gösteriliyor. Kartını gördükten sonra "Hazırım" butonuna bas.</p>
      </div>

      <div className="card-reveal-card">
        <Card cardId={currentCard} revealed={true} />
      </div>

      <div className="card-reveal-status">
        <span>Hazır: {readyCount}/{totalCount}</span>
        <div className="card-reveal-players">
          {lobby.players.map(player => (
            <div
              key={player.id}
              className={`card-reveal-player ${readyPlayers.includes(player.id) ? 'card-reveal-player--ready' : ''}`}
            >
              <div className="card-reveal-player-avatar">{player.name.charAt(0)}</div>
              <div className="card-reveal-player-name">{player.name}</div>
              {readyPlayers.includes(player.id) && (
                <div className="card-reveal-player-check">&#10003;</div>
              )}
            </div>
          ))}
        </div>
      </div>

      {!isReady ? (
        <div className="card-reveal-action">
          <Button
            onClick={handleReady}
            variant="primary"
            fullWidth={true}
            disabled={isMarking}
          >
            {isMarking ? 'Bekleniyor...' : 'Hazırım'}
          </Button>
        </div>
      ) : (
        <div className="card-reveal-waiting">
          <p>Diğer oyuncuların hazır olması bekleniyor...</p>
        </div>
      )}
    </div>
  );
};

export default CardRevealPhase;
